<script lang="ts">
  // Remove the legacy import
  // import { run } from 'svelte/legacy';

  import "../../app.css";
  import Header from "$lib/components/Header.svelte";
  import SideNav from "$lib/components/SideNav.svelte";
  import {leftSidebarIsOpenStore, showHeaderBanner} from "$lib/stores";
  import Modal from "$lib/components/Modal.svelte";
  import Toast from "$lib/components/Toast.svelte";
  import LoginRegisterWrapper from "$lib/components/LoginRegisterWrapper.svelte";
  import MobileNavbar from "$lib/components/MobileNavbar/MobileNavbar.svelte";
  import MobileSideNav from "$lib/components/MobileSideNav.svelte";
  import Footer from "$lib/components/Footer.svelte";
  import {page} from "$app/stores";
  import {locale} from "$lib/i18n";
  import type {LayoutData} from "../../../.svelte-kit/types/src/routes/$types";
  import Tournaments from "$lib/components/ModalContents/Tournament/Tournaments.svelte";
  import SearchModal from "$lib/components/ModalContents/Search/SearchModal.svelte";
  import CookiesPopup from "$lib/components/CookiesPopup.svelte";
  import DepositWrapper from "$lib/components/ModalContents/DepositWithdraw/DepositWrapper.svelte";
  import MiniKycVerification from "$lib/components/ModalContents/KYC/MiniKycVerification.svelte";
  import {onMount} from "svelte";
  import WheelSpin from "$lib/components/ModalContents/WheelSpin/SpinWheel.svelte";
  import PaymentIqIframe from "$lib/components/ModalContents/DepositWithdraw/Deposit/PaymentIQ/PaymentIqIframe.svelte";
  import SelfExclude from "$lib/components/ModalContents/SelfExclusion/SelfExclude.svelte";
  import {initWebSocket} from "$lib/services/socket.service";
  import OverlayLoader from "$lib/components/OverlayLoader.svelte";
  import TwoFactorAuthentication from "$lib/components/ModalContents/2FA/TwoFactorAuthentication.svelte";
  import ForgotPassword from "$lib/components/ModalContents/ForgotPassword/ForgotPassword.svelte";
  import ResetPassword from "$lib/components/ModalContents/ForgotPassword/ResetPassword.svelte";
  import TotpConfirm from "$lib/components/ModalContents/2FA/TotpConfirm.svelte";
  import RolloverDetails from "$lib/components/ModalContents/RolloverDetails.svelte";
  import type {IUser} from "$lib/interfaces/IUserMe";
  import {user} from '$lib/stores'
  import TournamentContent from "$lib/components/ModalContents/Tournament/TournamentContent.svelte";
  import RolloverTable from "./profile/rollover/components/RolloverTable.svelte";
  import TransactionDetails from "$lib/components/TransactionDetails/TransactionDetails.svelte";
  import {environment} from "$lib/env";

  // Use traditional export let for SvelteKit layouts
  export let data: LayoutData;
  
  // Use regular variables instead of $state
  let leftSidebarIsOpen = true;
  let userInfo: IUser | null = null;
  
  // Subscribe to the user store
  const unsubUser = user.subscribe(value => {
    userInfo = value;
  });
  
  // Subscribe to the sidebar store
  const unsubSidebar = leftSidebarIsOpenStore.subscribe(value => {
    leftSidebarIsOpen = value;
  });

  onMount(() => {
    if (data.token) {
      initWebSocket(`${environment.socketUrl}?token=` + data.token);
    }
    
    // Clean up subscriptions
    return () => {
      unsubUser();
      unsubSidebar();
    };
  });
</script>

<Header gameMode={$page.url.pathname.includes(`/${$locale}/game/`)} {data}/>
<div class="flex">
  {#if $page.url.pathname.includes(`/${$locale}/sports`)}
    <main class="{$showHeaderBanner ? 'mt-24 md:mt-24' : 'mt-16 md:mt-20'} w-full">
      <slot></slot>
    </main>
  {:else}
    <SideNav {data}/>
    <div class="w-full">
      <main
          class="{leftSidebarIsOpen ? 'md:pl-60': 'md:pl-20'} {$page.url.pathname.includes(`/${$locale}/game/`) ? 'w-full p-0 md:p-2' : 'p-4 md:p-2 mx-auto w-full md:max-w-screen-lg lg:max-w-screen-xl xl:max-w-screen-2xl'} {$showHeaderBanner && !$page.url.pathname.includes(`/${$locale}/game/`) ? 'mt-24 md:mt-24' : 'mt-16 md:mt-20'}">
        <slot></slot>
      </main>
      <Footer hide={$page.url.pathname.includes(`/${$locale}/game/`)} {data}/>
    </div>
  {/if}
</div>


<MobileSideNav {data}/>
<MobileNavbar gameMode={$page.url.pathname.includes(`/${$locale}/game/`)}/>

<Modal modalName="LoginModal">
  <LoginRegisterWrapper/>
</Modal>

<Modal modalName="RegistrationModal">
  <LoginRegisterWrapper isLogin={false}/>
</Modal>

<Modal modalName="SearchModal" widthClasses="w-full max-w-screen-xl" rounded="rounded-3xl">
  <SearchModal/>
</Modal>

<Modal modalName="ForgotPasswordModal">
  <ForgotPassword/>
</Modal>

<Modal modalName="ResetPasswordModal">
  <ResetPassword/>
</Modal>

<Modal modalName="TournamentsModal" widthClasses="w-full max-w-lg">
  <Tournaments/>
</Modal>

<Modal modalName="TournamentsContentModal" widthClasses="w-full max-w-lg" positionY="items-center">
  <TournamentContent/>
</Modal>

<Modal modalName="TransactionDetailsModal" widthClasses="w-full max-w-[560px] min-h-[472px]">
  <TransactionDetails/>
</Modal>


{#if userInfo}

  {#if !userInfo.selfExcluded}
  <Modal modalName="DepositModal" widthClasses="w-full max-w-[560px] mx-1" rounded="rounded-2xl">
    <DepositWrapper data={userInfo}/>
  </Modal>
  {/if}

  <Modal modalName="MiniKYCModal">
    <MiniKycVerification user={userInfo}/>
  </Modal>

  <Modal modalName="WheelSpinModal">
    <WheelSpin/>
  </Modal>

  <Modal modalName="PaymentIqIframe" widthClasses="w-full max-w-[560px] mx-1" rounded="rounded-2xl">
    <PaymentIqIframe/>
  </Modal>

  <Modal modalName="SelfExclusionModal">
    <SelfExclude user={userInfo}/>
  </Modal>

  <Modal modalName="2FAModal">
    <TwoFactorAuthentication/>
  </Modal>

  <Modal modalName="totpConfirmation">
    <TotpConfirm/>
  </Modal>

  <Modal modalName="RolloverTableModal" widthClasses="w-full max-w-fit">
    <RolloverTable/>
  </Modal>

  <Modal modalName="RolloverDetailsModal">
    <RolloverDetails/>
  </Modal>

  <!--  <Modal modalName="ConfirmationLimitModal">-->
  <!--    <ConfirmationLimitModal title="Limit update" subTitle="Confirm limit update" description="Are you sure you want to set Deposit Limits? If you set a limit, any request you make, to increase or remove that limit, will not take effect for 24 hours."/>-->
  <!--  </Modal>-->
{/if}

<Toast/>
<CookiesPopup acceptedCookies={data.acceptedCookies}/>
<OverlayLoader/>